import "./Unauthorize.css";
import alertWarning from "../../assets/svgs/alert-warning.svg";

const Unauthorize = () => {
  const selectedEnv = process.env.REACT_APP_KEYCLOAK_CLIENT;
  const environments = [
    {
      label: "ncm-client-qa",
      description: "Para o ambiente de QA e DEV do TRAI.",
      groups: ["IdM2BCD_TRAI_QA_Engineer", "dM2BCD_TRAI_QA_Tax"],
    },
    {
      label: "ncm-client-hom",
      description: "Para o ambiente de Homologação do TRAI.",
      groups: ["IdM2BCD_TRAI_HOM_Engineer", "IdM2BCD_TRAI_HOM_Tax"],
    },
    {
      label: "PRD",
      description: "Para o ambiente de Produção do TRAI.",
      groups: ["IdM2BCD_TRAI_PRD_Engineer", "dM2BCD_TRAI_PRD_Tax"],
    },
  ];

  const env = environments.find((e) => e.label === selectedEnv);

  return (
    <div className="container-unauthorize">
      <div className="unautho-container">
        <div className="container-una">
          <div>
            <img
              className="img-alert"
              src={alertWarning}
              alt="imagem de alerta"
            />
          </div>
          <span className="text-exp">Não autorizado</span>
          <div className="line">.</div>
          <div className="text-apli">
            Você não possui acesso à aplicação do TRAI. Para obter acesso,
            solicite a inclusão em um dos grupos abaixo por meio do link:
            <a
              href="https://oneidm.bosch.com/oneidm/html/rbwebshop/#/start/home"
              target="_blank"
              className="link-one"
              rel="noreferrer"
            >
              onelDM
            </a>
          </div>
        </div>

        <div className="container-grup">
          <div className="text-grup">
            <span>Grupos</span>
          </div>

          <div className="container-role">
            <span>
              {env?.description}
            </span>
          </div>
          {env?.groups.map((group) => (
            <div className="container-role" key={group}>
              <span>
                <i>{group}</i>
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Unauthorize;
